import { CompanyTitledPage } from "../TitledPage";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Button from "@mui/material/Button";

import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../components/PartHeader";
import CommodityOwnerNewForm from "./CommodityOwnerNewForm";
import { INITIAL_COMMODITY } from "./commodityInitial";
import { insertCommodityOwner } from "../../http/api/CommodityOwnerAPI";

// 新規荷主更新ページ
const CommodityOwnerInsertPage = () => {
  const navigate = useNavigate();
  const formRef = useRef();
  const refs = useRef({});
  useEffect(() => {
    Object.keys(INITIAL_COMMODITY).forEach((key) => {
      refs.current[key] = React.createRef(INITIAL_COMMODITY[key]);
    });
  }, []);
  const handleClickReturn = (event) => {
    navigate(-1);
  };

  // 登録ボタンをクリックするイベント
  async function handleClickInsert() {
    try {
      formRef.current.setTouched(
        Object.keys(formRef.current.values).reduce(
          (touched, key) => ({ ...touched, [key]: true }),
          {}
        )
      );
      await formRef.current.validateForm();
      const errors = formRef.current.errors;
      const hasErrors = errors && Object.keys(errors).length > 0;

      if (hasErrors) {
        alert("入力不正項目があるため、ご確認お願い致します。");
        console.log(errors);
      } else {
        let insertValue = formRef.current;
        Object.keys(refs.current).forEach((key) => {
          const element = refs.current[key].current;
          if (element) {
            if (key === "areaCd") {
              insertValue[key] = element.value === -1 ? null : element.value;
            } else{
              insertValue[key] = element.value;
            }
          }
        });
        insertValue.createdId = 1;
        insertValue.updatedId = 1;
        insertValue.invoiceRegistrationHistoryList
          = formRef.current.values.invoiceRegistrationHistoryList
            .map((h => ({
              ...h,
              registrationDate: h.registrationDate || null,
              cancellationDate: h.cancellationDate || null,
            })));

        console.log("Insert CommodityOwner data : ", insertValue);
        let response = await insertCommodityOwner(insertValue);
        alert("荷主を登録しました。");
        navigate("/company/commodity_owner");
      }
    } catch {
      alert("荷主を登録できませんでした。");
    }
  }

  return (
    <CompanyTitledPage title="荷主登録">
      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              荷主情報の入力
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={handleClickInsert}
              id="commodity-owner-form-submit-button"
            >
              登録
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={handleClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>
      {/* 荷主情報 */}
      <CommodityOwnerNewForm
        innerRef={formRef}
        commodityOwnerInfo={INITIAL_COMMODITY}
        isUpdateMode={false}
        refs={refs}
      />
    </CompanyTitledPage>
  );
};
export default CommodityOwnerInsertPage;
